import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { jobTitles, jobSeniorities, countries } from "@/components/data/Options";

type TVipCustomerForm = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    company: string;
    job_title: string;
    job_seniority: string;
    country: string;
    acceptTerms: boolean;
    acceptEmailMarketing: boolean;
};

const App: React.FC = () => {
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<TVipCustomerForm>({});

    const onSubmit = (data: TVipCustomerForm) => {
        setSuccess("");
        setError("");

        const formData = new FormData();

        formData.append("shop", window.Shopify.shop || "");
        formData.append("first_name", data.first_name);
        formData.append("last_name", data.last_name);
        formData.append("email", data.email);
        formData.append("phone", data.phone);
        formData.append("company", data.company);
        formData.append("job_title", data.job_title);
        formData.append("job_seniority", data.job_seniority);
        formData.append("country", data.country);

        fetch(process.env.MIX_APP_URL + "/api/vip-customer", {
            method: "post",
            body: formData
        })
            .then((response) => {
                if (response.ok) {
                    return "ok";
                }
                return response.json();
            })
            .then((responseJson) => {
                responseJson === "ok" ? setSuccess("Thank you for registering.") : setError(responseJson);
                console.log(responseJson);
            })
            .catch((error) => {
                setError("Something is not right! Please reload the page and try again.");
                console.log(error);
            });

        return false;
    };

    return (
        <div className="cbs-conainer">
            <style>{`
                .cbs-is-invalid {
                    border: 1px solid red;
                }
                .cbs-error{
                    color:red;
                    font-size: 12px;
                    font-weight: 420;
                    letter-spacing: 0.25px;
                    text-transform: uppercase;
                }
                #cbs-vip-form {
                    font-family: 'Lato', sans-serif;
                }
                .cbs-conainer {
                    max-width: 500px;
                    margin: auto;
                }
                #cbs-vip-form label {
                    display: inline-block;
                    width: 150px;
                    text-align: right;
                    padding-right: 10px;
                }
                #cbs-vip-form input,  #cbs-vip-form select{
                    display: inline-block;
                    width: 300px;
                    padding:3px;
                }
                #cbs-vip-form .cbs-accept {
                    padding-left:150px;
                }
                #cbs-vip-form .cbs-accept label {
                    text-align: left;
                    text-wrap: nowrap;
                    padding: 0 !important;
                }
                #cbs-vip-form .cbs-accept input {
                    display: inline-block;
                    width: auto;
                }
                #cbs-vip-form .cbs-error {
                    padding-left:150px;
                }
                .consent-text{
                    color: #646464;
                    font-size: 12px;
                    font-weight: 420;
                    letter-spacing: 0.25px;
                    text-transform: uppercase;
                }
            `}</style>
            <div className="cbs-success">{success}</div>
            <div className="cbs-error">{error}</div>
            <form id="vip-customer-form" className="cbs-form" onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <label>First Name</label>
                    <input
                        type="text"
                        {...register("first_name", { required: "Please enter your first name" })}
                        className={`${errors.first_name ? "cbs-is-invalid" : ""}`}
                    />
                    <div className="cbs-error">{errors.first_name?.message}</div>
                </div>
                <div>
                    <label>Last Name</label>
                    <input
                        type="text"
                        {...register("last_name", { required: "Please enter your last name" })}
                        className={`${errors.last_name ? "cbs-is-invalid" : ""}`}
                    />
                    <div className="cbs-error">{errors.last_name?.message}</div>
                </div>
                <div>
                    <label>Email</label>
                    <input
                        type="text"
                        {...register("email", { required: "Please enter your email" })}
                        className={`${errors.email ? "cbs-is-invalid" : ""}`}
                    />
                    <div className="cbs-error">{errors.email?.message}</div>
                </div>
                <div>
                    <label>Phone</label>
                    <input
                        type="text"
                        {...register("phone", { required: "Please enter your phone" })}
                        className={`${errors.phone ? "cbs-is-invalid" : ""}`}
                    />
                    <div className="cbs-error">{errors.phone?.message}</div>
                </div>
                <div>
                    <label>Company name</label>
                    <input type="text" {...register("company")}
                           className={`${errors.company ? "cbs-is-invalid" : ""}`} />
                    <div className="cbs-error">{errors.company?.message}</div>
                </div>
                <div>
                    <label>Job title</label>
                    <select {...register("job_title")}>
                        <option value=""></option>
                        {jobTitles.map((x) => (
                            <option value={x}>{x}</option>
                        ))}
                    </select>
                    <div className="cbs-error">{errors.job_title?.message}</div>
                </div>
                <div>
                    <label>Job seniority</label>
                    <select {...register("job_seniority")}>
                        <option value=""></option>
                        {jobSeniorities.map((x) => (
                            <option value={x}>{x}</option>
                        ))}
                    </select>
                    <div className="cbs-error">{errors.job_seniority?.message}</div>
                </div>
                <div>
                    <label>Country</label>
                    <select
                        {...register("country", { required: "Please select your country" })}
                        className={`${errors.country ? "cbs-is-invalid" : ""}`}
                    >
                        <option value=""></option>
                        {countries.map((x) => (
                            <option value={x}>{x}</option>
                        ))}
                    </select>
                    <div className="cbs-error">{errors.country?.message}</div>
                </div>

                <div className="cbs-accept">
                    <input
                        type="checkbox"
                        {...register("acceptTerms", { required: true })}
                        className={`form-check-input ${errors.acceptTerms ? "cbs-is-invalid" : ""}`}
                    />
                    <label htmlFor="acceptTerms" className={`${errors.acceptTerms ? "cbs-error" : ""}`}>
                        I have read and agree to the Terms
                    </label>
                    <div className="cbs-error">{errors.acceptTerms?.message}</div>
                </div>
                <div className="cbs-accept">
                    <input
                        type="checkbox"
                        {...register("acceptEmailMarketing", { required: true })}
                        className={`form-check-input ${errors.acceptEmailMarketing ? "cbs-is-invalid" : ""}`}
                    />
                    <label htmlFor="acceptEmailMarketing"
                           className={`${errors.acceptEmailMarketing ? "cbs-error" : ""}`}>
                        I agree to receive the downloadable content and occasional marketing emails from Colebrook
                        Bosson Saunders.
                    </label>
                    <div>
                        <div className={"consent-text"}>
                            I understand I can unsubscribe at any time.
                        </div>
                    </div>
                    <div className="cbs-error">{errors.acceptEmailMarketing?.message}</div>
                </div>
                <div>
                    <button type="submit">Register</button>
                    <button type="button" onClick={() => reset()}>
                        Reset
                    </button>
                </div>
            </form>
        </div>
    );
};

export default App;
